/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { LOCAL_TRANSLATION_LANGUAGE } from '../../constants/app.constant';

@Injectable()
export class AcceptLanguageInterceptor implements HttpInterceptor {
    constructor(private translateService: TranslateService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });

        if (!request.headers.has('Accept')) {
            request = request.clone({ headers: request.headers.set('Accept', 'application/json') });
        }

        request = request.clone({
            headers: request.headers.set(
                'Accept-Language',
                this.translateService.currentLang || LOCAL_TRANSLATION_LANGUAGE.EN,
            ),
        });

        return next.handle(request);
    }
}
